import { Moment } from 'moment';

import { PhoneType } from '../enums';
import { MemberPhoneInvalidateReason } from '../enums/MemberPhoneInvalidateReason';
import { Employee } from './Employee';
import { make, makeUnix } from './Model';
import { Phone } from './Phone';
import { UserPhone } from './UserPhone';

export class MemberPhone extends UserPhone {
  authenticationPhone = false;

  emrIntegrated?: boolean;

  crmIntegrated?: boolean;

  preferred = false;

  inactivatedAt?: Moment;

  inactivatedBy?: Employee;

  inactivatedReason?: MemberPhoneInvalidateReason;

  inactivatedReasonOther = '';

  reactivatedAt?: Moment;

  reactivatedBy?: Employee;

  constructor(obj: any) {
    super(obj);
    this.authenticationPhone = obj.authenticationPhone;
    this.crmIntegrated = obj.crmIntegrated;
    this.emrIntegrated = obj.emrIntegrated;
    this.inactivatedAt = makeUnix(obj.inactivatedAt);
    this.inactivatedBy = make(obj.inactivatedBy, Employee);
    this.inactivatedReason =
      MemberPhoneInvalidateReason.byKey[obj.inactivatedReason];
    this.inactivatedReasonOther = obj.inactivatedOther;
    this.reactivatedAt = makeUnix(obj.reactivatedAt);
    this.reactivatedBy = make(obj.reactivatedBy, Employee);
    this.preferred = obj.preferred;
    // TODO: Remove primary deprecated support
    this.primary =
      obj.primary ||
      obj.preferred ||
      (this.phone.type === PhoneType.HOME && obj.primaryHome) ||
      (this.phone.type === PhoneType.CELL && obj.primaryCell);
  }

  get readOnly() {
    return this.emrIntegrated === true || this.crmIntegrated === true;
  }

  get isPhoneEmrIntegrated() {
    return this.emrIntegrated;
  }

  get isPhoneCrmIntegrated() {
    return this.crmIntegrated;
  }

  static filterActive(phone: MemberPhone) {
    return !phone.inactivatedAt || phone.reactivatedAt;
  }

  static sortByType(a: MemberPhone, b: MemberPhone) {
    if (a.preferred) return -1;
    if (b.preferred) return 1;
    return UserPhone.sortByType(a, b);
  }

  static clone(phone: MemberPhone) {
    const clone = { ...phone, phone: Phone.clone(phone.phone) };
    return Object.setPrototypeOf(clone, MemberPhone.prototype);
  }
}

export default MemberPhone;
